import { render, staticRenderFns } from "./LeftHeader.vue?vue&type=template&id=996d48fe&scoped=true&"
import script from "./LeftHeader.vue?vue&type=script&lang=js&"
export * from "./LeftHeader.vue?vue&type=script&lang=js&"
import style0 from "./LeftHeader.vue?vue&type=style&index=0&id=996d48fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996d48fe",
  null
  
)

export default component.exports